"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var AgreementBlockContainer_1 = require("@CommonFrontend/AgreementView/AgreementBlockContainer");
var AgreementModal_1 = require("@CommonFrontend/AgreementView/AgreementModal");
var DIProvider_1 = __importDefault(require("@CommonFrontend/DIProvider/DIProvider"));
var MountReactComponent_1 = __importDefault(require("@CommonFrontend/MountReactComponent/MountReactComponent"));
var AngularSyncStore_1 = require("@CommonFrontend/Utils/AngularSyncStore");
var inversify_1 = require("inversify");
var react_1 = __importDefault(require("react"));
var AgreementBlockEditor_1 = require("./Components/AgreementBlockEditor");
var AgreementBlockController = (function () {
    function AgreementBlockController(createUi, di, block, modal, $timeout) {
        var _this = this;
        this.ui = createUi(require("./Agreement.html"), {
            blockUi: null,
            $init: function ($scope) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.ui.blockUi = (0, MountReactComponent_1.default)(createUi, di)(react_1.default.createElement(WrappedAgreementBlock, { di: di, modalService: modal, $scope: $scope, $timeout: $timeout, block: block }));
                    return [2];
                });
            }); },
        });
    }
    return AgreementBlockController;
}());
exports.default = AgreementBlockController;
var WrappedAgreementBlock = function (_a) {
    var di = _a.di, modalService = _a.modalService, $scope = _a.$scope, $timeout = _a.$timeout, block = _a.block;
    return (react_1.default.createElement(DIProvider_1.default, { container: function () {
            var container = new inversify_1.Container({ skipBaseClassChecks: true });
            container.bind("angularData").toConstantValue({ showAgreementModal: true, agreementBlock: block });
            container.bind(AgreementModal_1.AgreementStore).toSelf();
            container.bind(AngularSyncStore_1.AngularSyncServices.$).toConstantValue(!!$scope ? { $scope: $scope, $timeout: $timeout } : { disableSync: true });
            container.bind("modalService").toConstantValue(modalService);
            return container;
        } },
        react_1.default.createElement(AgreementBlockContainer_1.AgreementBlockContainer, { block: block },
            react_1.default.createElement(AgreementBlockEditor_1.AgreementBlockEditor, { di: di }))));
};
